(() => {
  const STORAGE_KEY = 'hadeva_campaign_context_v1';
  const EDITS = {
    'new-in': { label: 'New In', path: '/collections/new-arrivals' },
    'jewelry': { label: 'Jewelry', path: '/collections/jewelry' },
    'press-ons': { label: 'Press-On Nails', path: '/collections/nails' },
    'hair': { label: 'Hair Accessories', path: '/collections/hair-accessories' },
    'bags': { label: 'Bags & Accessories', path: '/collections/bags-accessories' },
    'under-1500': { label: 'Under Rs. 1,500', path: '/collections/under-rs-1-500' },
    'under-3000': { label: 'Under Rs. 3,000', path: '/collections/under-rs-3-000' }
  };
  const PATH_TO_EDIT = Object.fromEntries(Object.entries(EDITS).map(([key, value]) => [value.path, key]));
  const TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];

  const safeParse = (value) => {
    if (!value) return null;
    try { return JSON.parse(value); } catch (_) { return null; }
  };

  const read = () => {
    try { return safeParse(sessionStorage.getItem(STORAGE_KEY)); } catch (_) { return null; }
  };

  const write = (value) => {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (_) {}
  };

  const normalizePath = (pathname) => pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;

  const params = new URLSearchParams(window.location.search);
  const incomingEdit = params.get('edit');
  const tracking = {};
  TRACKING_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) tracking[key] = value;
  });

  let context = read() || {};
  if (incomingEdit && EDITS[incomingEdit]) {
    context = {
      ...context,
      edit: incomingEdit,
      tracking: { ...(context.tracking || {}), ...tracking },
      startedAt: context.startedAt || Date.now(),
      updatedAt: Date.now()
    };
    write(context);
  } else if (Object.keys(tracking).length) {
    context = {
      ...context,
      tracking: { ...(context.tracking || {}), ...tracking },
      startedAt: context.startedAt || Date.now(),
      updatedAt: Date.now()
    };
    write(context);
  }

  const currentPath = normalizePath(window.location.pathname);
  if (context.edit && PATH_TO_EDIT[currentPath] && PATH_TO_EDIT[currentPath] !== context.edit) {
    context.edit = PATH_TO_EDIT[currentPath];
    context.updatedAt = Date.now();
    write(context);
  }

  const renderContext = () => {
    const container = document.querySelector('[data-hadeva-campaign-context]');
    if (!container) return;

    const stored = read();
    const config = stored?.edit ? EDITS[stored.edit] : null;
    if (!config) {
      container.hidden = true;
      return;
    }

    const label = container.querySelector('[data-hadeva-campaign-label]');
    const link = container.querySelector('[data-hadeva-campaign-link]');
    if (label) label.textContent = 'From the ' + config.label + ' edit';
    if (link) link.href = config.path;
    container.hidden = false;
    document.documentElement.dataset.hadevaEdit = stored.edit;
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;

    const stored = read();
    if (!stored?.edit) return;

    let url;
    try { url = new URL(anchor.href, window.location.origin); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;

    const nextEdit = PATH_TO_EDIT[normalizePath(url.pathname)];
    if (!nextEdit) return;

    stored.edit = nextEdit;
    stored.updatedAt = Date.now();
    write(stored);
  }, { capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderContext, { once: true });
  } else {
    renderContext();
  }

  document.addEventListener('shopify:section:load', renderContext);
})();
